// @ts-ignore
import mapbox from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax

export const ACCESS_TOKEN =
  'pk.eyJ1IjoiZ3JlZ29pcmVsYWMiLCJhIjoiY2t0bXpkZGVqMHZudjJubWo0cWV3ZzJ5MSJ9.IF0ZVMuycJWzAlz02Wr84g';
mapbox.accessToken = ACCESS_TOKEN;

export default mapbox;
